import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class RegistruService {
    private token!: string;
    private httpOptions: any;

    private registruId = new Subject<{ registruId: number }>();
    currentRegistruId$ = this.registruId.asObservable();

    private basePath = environment.interop.basePath;
    private getRegistreDTURL =
        this.basePath + environment.interop.urbanism.nomenclatoare.registru.listDT;

    private getRegistreListURL =
        this.basePath + environment.interop.urbanism.nomenclatoare.registru.list;

    private addRegistruDocOficialURL =
        this.basePath +
        environment.interop.urbanism.nomenclatoare.registru.storeDocumentOficial;

    private editRegistruDocOficialURL =
        this.basePath +
        environment.interop.urbanism.nomenclatoare.registru.editDocumentOficial;

    private exportRegistruURL =
        this.basePath +
        environment.interop.urbanism.nomenclatoare.registru.exportRegister;

    private exportCSVRegistruURL =
        this.basePath +
        environment.interop.urbanism.nomenclatoare.registru.exportCSVRegister;

    private getJudeteUrl =
        environment.interop.authCore.basePath + environment.interop.authCore.nomenclatoare.judet.list;

    constructor(private http: HttpClient) { }

    changeRegistruId(registru_id: { registruId: number }) {
        this.registruId.next(registru_id);
    }

    getRegistreDT() {
        return this.http.get(this.getRegistreDTURL, this.httpOptions);
    }

    getRegistre() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getRegistreListURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        slug: item.slug,
                        name: item.name,
                        active: item.active,
                        archived: item.archived ? item.archived : null,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get reigstre types:', error);
                    return throwError(error);
                })
            );
    }

    addRegistruDocOficial(data: any, slug: string) {
        return this.http.post(
            this.addRegistruDocOficialURL + slug,
            data,
            this.httpOptions
        );
    }

    editRegistruDocOficial(data: any, id: number) {
        return this.http.put(
            this.editRegistruDocOficialURL + id,
            data,
            this.httpOptions
        );
    }

    exportRegistru(data: any, isCSV: boolean = false) {
        if (!isCSV) {
            return this.http.post(this.exportRegistruURL, data, { responseType: 'blob' as 'json' });
        } else {
            return this.http.post(this.exportCSVRegistruURL, data, { responseType: 'blob' as 'json' });
        }
    }

    getJudete() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getJudeteUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get judete:', error);
                    return throwError(error);
                })
            );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
